import type { FaireProductEntity } from "../../entity_types/product";

export const p_x93mxzh4yt: FaireProductEntity = {
  token: "p_x93mxzh4yt",
  type: "product",
  name: "Large Capacity Canvas Fashion Women's Tote Bag Shoulder Bag",
  brandToken: "b_3fb7o7n9vq",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/5e5d4574fd0afc25949b240532105dcc55da66fe51e1d4212f735606dae5ba06.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc5e39e15ed7a90fda5a125158d0d10839d6ce00bc1ec1ce1fa12947f7709e63.jpeg",
    "https://cdn.faire.com/fastly/e7583612d8d405b9ed1919c8c2a4459124696fc3dfe5a1d2e24dc1da94e200c8.jpeg",
    "https://cdn.faire.com/fastly/62cdee354399c6f43ab05a1bacbdf5000f2b29d720f7d1496d8e6ab73439d650.jpeg",
    "https://cdn.faire.com/fastly/aaa5fd769516fd8b9262973e4d95a9af28cdd6fb72628140253971339bf99aa9.jpeg",
    "https://cdn.faire.com/fastly/6458ec0af3cfe397a6b8af48599235dfa05818501e3d35ae83f7aa9b6e87bfe8.jpeg",
    "https://cdn.faire.com/fastly/7277584f2f8baef0088cba6ef031bcb5abf9f6cba320d775b921151eb293dc0a.jpeg",
    "https://cdn.faire.com/fastly/b792040dfe1bc7ac470b937273113d1e99d114771d4013eeb37f40772fd4738e.jpeg",
    "https://cdn.faire.com/fastly/50451c287135b01247ad81ff4a6eed8a827840cf372650bce40b85bae73f58e6.jpeg",
    "https://cdn.faire.com/fastly/9b4e747341edaf1325e7e7a4a3b988c4e672071779ff4a58507da37d02fa1342.jpeg",
    "https://cdn.faire.com/fastly/a19d9cfa7b8e5b955859983db952822587b527fd8700e853ee32c9abbccd75a0.jpeg",
    "https://cdn.faire.com/fastly/efc8c294e909d0e207a4d575ccd3868d5c0beae193c4066f842faedce8ec3925.jpeg",
    "https://cdn.faire.com/fastly/c0ead7e9b58802feb3d5d06be22d0a04ff6f79cdb67403a945873b121de54270.jpeg",
    "https://cdn.faire.com/fastly/24e26046cf8cf25471a91d54b5d26f81c455af4b07a48203a643251f3dbe7c9b.jpeg",
    "https://cdn.faire.com/fastly/1c3310b3a6dc309d14ce4965e6866bfb060557ec61656c96fad1c882b7d8de49.jpeg",
    "https://cdn.faire.com/fastly/3c4d74ded2afc02a6f06cd069e61b19eb035c3bb1b305fb0a0696f3a44b58133.jpeg",
    "https://cdn.faire.com/fastly/bfa9c953af15350173da2c021657b63d786851a9b462ce7d34314d9fb4008ca5.jpeg",
    "https://cdn.faire.com/fastly/fb3dae065ba90408424a222c1a4af4aca8180e010b55cd2a0a030f460f53c131.jpeg",
    "https://cdn.faire.com/fastly/4c0b20b2d52d2806f1c4758f237845942a056c65519a33f57896c599071d9df7.jpeg",
    "https://cdn.faire.com/fastly/66f6c8e784eb293de96628a2ef2fa9d3773690a4da125b97a3e805003e3bd295.jpeg"
  ],
  priceDollars: 10.38,
  description: "Dimensions: 38*12*28 cm/ 15*4.7*11 inch\n\nIt has Zippered hidden pockets, ID pockets\nThe design features attention to detail, with plenty of space in the bag.\n\nSuitable for daily street wear, commute to work, go out to play",
  tags: [],
  msrpDollars: 20.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:51.153Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
